import { Injectable } from '@angular/core';
import { ContactData, DictList, ContactInfo } from '@models/real-name-model';
import isEmpty from 'lodash/isEmpty';
import { Base64 } from 'js-base64';
@Injectable({
    providedIn: 'root'
})
    
export class RFactoryService {
    public contactData: ContactData;
    public contactList: ContactInfo[];
    public otherBZ: boolean = false;
    public editKey: string;
    public dictList: DictList;
    public curContacter: ContactInfo;
    public prePage: string;
    public businessKey: string;
    public ownerGID: string;
    public encodeGID: string;
    public entryPoint: string;
    public selectNum: number; // default is 1
    public isFixedNum: boolean; // default is true
    public checkedParam: boolean = false;
    public toastKey: string;
    public addOwner: boolean = false;
    public backTwiceFlag: boolean = false;
    public backFlag: boolean = false;
    public showedNoOwner: boolean = false;
    public saArea: any;
    public checkedAgeBand: boolean = false;
    public ageBandToggle: boolean = false;
    public listUpdateFlag: boolean = true;
    public tmpBtnTxt: string;
    public cleared: boolean = false;
    public enoughFlag: boolean = false;
    public checkedParamFlag: boolean = false;
    public gidType: string; //(ID_CARD | HK_MA_RESID | TW_RESID | PASSPORT | HK_MA_TW_RESID | FOREIN_FOREVER_ID_CARD | CN_TRAVEL)
    public addAction: boolean = false;
    public visitorListShowView: boolean = false;
    public visitDate: string;
    public ticketType: string;
    public order: string;

    constructor() { }

    set(key: string, value: any) {
        sessionStorage.setItem(`${key}`, JSON.stringify(value));
    }
    
    get(key: string) {
        return sessionStorage.getItem(`${key}`) && sessionStorage.getItem(`${key}`) != 'undefined' ? JSON.parse(sessionStorage.getItem(`${key}`)) : null;
    }

    public checkParams() { 
        this.checkedParamFlag = true;
        const tmpData = new URLSearchParams(window.location.search);
        this.prePage = tmpData.get('prePage');
        this.otherBZ = (!this.prePage || this.prePage != 'setting');
        sessionStorage.setItem('otherBZ', `${this.otherBZ}`);
        if (this.otherBZ && !this.checkedParam) {
            this.checkedParam = true;
            this.entryPoint = tmpData.get('entryPoint');
            this.selectNum = this.visitDate? 1 : (Number(tmpData.get('selectNum')) || 1);
            this.isFixedNum = this.visitDate? true : (tmpData.get('isFixedNum') ? tmpData.get('isFixedNum')?.toLowerCase() === 'true' : true);
            const key = tmpData.get('businessKey');
            this.businessKey = key && !isEmpty(key) ? decodeURIComponent(key) : null;
            this.ownerGID = sessionStorage.getItem(`${this.entryPoint}_gid`);
            if (this.ownerGID && this.ownerGID !== '' && this.ownerGID !== 'null' &&  this.ownerGID !== 'undefined') { 
                this.encodeGID = Base64.decode(this.ownerGID);
                sessionStorage.setItem('encodeGID', this.encodeGID);
            }
            this.gidType = tmpData.get('gidType');
            this.ageBandToggle = tmpData.get('ageBandToggle') ? tmpData.get('ageBandToggle')?.toLowerCase() === 'on' : true;  //default is on
            //only for purchase flow start== 
            this.visitDate = tmpData.get('visitDate');
            if (this.visitDate) { 
                this.ticketType = tmpData.get('ticketType');
                this.order = tmpData.get('order');
            }
            //only for purchase flow end==
            sessionStorage.setItem('ageBandToggle', `${this.ageBandToggle}`);
        }
    }

    public async clearAction(listFlag?: boolean) { 
        if (!listFlag || listFlag && !this.cleared) { 
            console.log('clearAction.....');
            this.cleared = listFlag;
            this.checkedParam = false;
            this.contactData = null;
            this.contactList = null;
            this.enoughFlag = false;
            sessionStorage.removeItem('contactData');
            sessionStorage.removeItem('contactList');
            sessionStorage.setItem('otherBZ', null);
            sessionStorage.removeItem('encodeGID');
        }
    }

}